import { render, staticRenderFns } from "./UbrRules.vue?vue&type=template&id=35710da8&scoped=true"
import script from "./UbrRules.vue?vue&type=script&lang=js"
export * from "./UbrRules.vue?vue&type=script&lang=js"
import style0 from "./UbrRules.vue?vue&type=style&index=0&id=35710da8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35710da8",
  null
  
)

export default component.exports